declare global {
  interface Window {
    userToImpersonate?: string;
    fakePermissions?: Permission[] | undefined;
  }
}

export function getImpersonatedUser(): string | undefined {
  return window.userToImpersonate;
}
export function getFakePermissions(): Permission[] | undefined {
  return window.fakePermissions;
}
export function setImpersonatedUser(userToImpersonate: string) {
  window.userToImpersonate = userToImpersonate;
}
export function setFakePermissions(fakePermissions: Permission[] | undefined) {
  window.fakePermissions = fakePermissions;
}
